/*
 * Extract the first survey from a CDF or return 'AllSurveys'.
 *
 * Returns text.
 */
export default function getSurveyForCdf(cdf) {
  const surveyList = cdf.SurveyList;
  if (!surveyList || surveyList.length > 1) {
    return 'AllSurveys';
  }
  return surveyList[0];
}



// WEBPACK FOOTER //
// ./app/utils/AYDAUtils/getSurveyForCdf.js